module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box",
    class: _vm.active ? 'active' : null,
    attrs: {
      "id": _vm.service.title.toLowerCase()
    },
    on: {
      "click": _vm.makeActive
    }
  }, [_c('div', {
    staticClass: "heading"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.service.title))])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('p', {
    staticClass: "description"
  }, [_vm._v(_vm._s(_vm.service.description))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-76082816","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Services/Service.vue
// module id = 924
// module chunks = 1